import { motion } from 'framer-motion';
import { CheckCircle2, AlertCircle, Ban } from 'lucide-react';

export const SubsidyEligibility = ({ scheme }) => (
  <section className="py-16 bg-[#f8fafc]">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid md:grid-cols-2 gap-12">
        <div>
          <h2 className="font-heading text-2xl font-semibold text-[#0f172a] mb-6 flex items-center gap-3">
            <CheckCircle2 className="text-green-500" />
            Eligibility Criteria
          </h2>
          <ul className="space-y-3">
            {scheme.eligibility.map((item, index) => (
              <motion.li
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.3, delay: index * 0.05 }}
                className="flex items-start gap-3"
              >
                <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                <span className="text-[#0f172a]">{item}</span>
              </motion.li>
            ))}
          </ul>
        </div>
        {scheme.ineligible && (
          <div>
            <h2 className="font-heading text-2xl font-semibold text-[#0f172a] mb-6 flex items-center gap-3">
              <Ban className="text-red-500" />
              Not Eligible
            </h2>
            <ul className="space-y-3">
              {scheme.ineligible.map((item, index) => (
                <motion.li
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.3, delay: index * 0.05 }}
                  className="flex items-start gap-3"
                >
                  <AlertCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                  <span className="text-[#64748b]">{item}</span>
                </motion.li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  </section>
);
